<template>
  <div ref="whole_page">
    <!-- Data Table To Display The BulkUpload -->
    <vs-card class="mb-4">
      <div class="vx-row">
        <div class="vs-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2  w-full">
          <h5>Company</h5>
          <h3>{{bulkFeedback.batchInfo.company}}</h3>
        </div>
        <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2  w-full">
          <h5>Batch Created</h5>
          <h3>{{bulkFeedback.batchInfo.createdOn}}</h3>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vs-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full">
          <h5>Students</h5>
          <h3>{{bulkFeedback.batchInfo.students}}</h3>
        </div>
        <div class="vs-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full">
          <h5>Errors</h5>
          <h3>{{bulkFeedback.batchInfo.errors}}</h3>
        </div>
      </div>
      <div class="vx-row mt-4 mb-4">
        <div class="vs-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 w-full">
          <h5>Uploaded File</h5>
          <a :href="bulkFeedback.batchInfo.fileUrl" download >click to download</a>
        </div>
      </div>
    </vs-card>

    <vs-card>
      <vs-table ref="studentList" stripe class="vs-con-loading__container" single pagination :max-items="tasksPerPage" search  @selected="studentOptions" :data="filteredBatchList">
        <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
          <!-- ITEMS PER PAGE -->
          <div class="vx-row w-full">
            <div style="margin-left: 20px;" class="vx-col s:w-1/2 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/4">
              <vs-dropdown  vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col w-full">
                <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                  <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ filteredBatchList.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : filteredBatchList.length }} of {{ filteredBatchList.length }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="tasksPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=25">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=50">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="tasksPerPage=100">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div class="vx-col w-1/4 flex">
              <div class="flex">
                <vs-checkbox v-model="showErrors" color="success">Only Errors</vs-checkbox>
                <vs-checkbox v-model="showRemoved" color="success">Hide Removed</vs-checkbox>
              </div>
            </div>
          </div>
        </div>
      
        <template slot="thead">
          <vs-th sort-key="userFirstName">First Name</vs-th>
          <vs-th sort-key="userLastName">Last Name</vs-th>
          <vs-th sort-key="idNumber">Id Number</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="mobile">Mobile</vs-th>
          <vs-th sort-key="work">Work</vs-th>
          <vs-th sort-key="completed">Completed On</vs-th>
          <vs-th sort-key="bulkErrorTypeId">Error</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :state="row.bulkErrorType ? 'danger' : 'success'" :data="row" :key="indextr" v-for="(row, indextr) in data"> 
 
            <vs-td :data="data[indextr].userFirstName">
             {{ row.userFirstName }}
           </vs-td> 

           <vs-td :data="data[indextr].userLastName">
             {{ row.userLastName }}
           </vs-td> 

           <vs-td :data="data[indextr].idNumber">
             {{ row.idNumber }}
           </vs-td> 

           <vs-td :data="data[indextr].email">
             {{ row.newEmail ? row.newEmail : row.email }}
           </vs-td> 
           
           <vs-td :data="data[indextr].mobile">
             {{ row.mobile }}
           </vs-td> 

           <vs-td :data="data[indextr].work">
             {{ row.work }}
           </vs-td>

           <vs-td :data="data[indextr].completed">
             {{ row.completed != "n/a" ? row.completed : '' }}
           </vs-td>

           <vs-td :data="data[indextr].bulkErrorType">
             {{ row.bulkErrorType }}
           </vs-td>

           <!-- <vs-td  :data="data[indextr].bulkErrorTypeId">
              <div v-if="row.bulkErrorTypeId">
                <vs-button size="small" icon-pack="feather" icon="icon-edit-2" @click.prevent.stop="studentOptions(row.bulkErrorTypeId)" ></vs-button>
              </div>
            </vs-td> -->

          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <vs-popup ref="studentDetails" id="studentDetails" title="Review Info" class="vs-con-loading__container" :active.sync="studentDetailsActive">
      
      <div class="flex flex-wrap wrapper-Review-Data">
      <!-- Data in Uploaded File -->
        <div class="vs-row w-full mb-2">
          <div class="vs-col w-full">
            <v-select ref="actionDropDown" class="w-full " placeholder="Select Action" :options="actionOptions" v-model="actionDropDown"></v-select>
          </div>
        </div>
        <div class="vx-row w-1/2 pb-3">
          <div class="vx-col w-full mb-2">
            <h3>CSV File Data</h3>
          </div>
          <div class="vx-col w-full mb-2">
            <label>First Name</label>
            <vs-input autocomplete="off"  :danger="selectedStudentData.userFirstName != systemUserData.userFirstName" :disabled="selectedStudentData.userFirstName == systemUserData.userFirstName" onClick="this.select();" class="w-full" name="Name" v-model="selectedStudentData.userFirstName" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Last Name</label>
            <vs-input autocomplete="off" :danger="selectedStudentData.userLastName != systemUserData.userLastName" :disabled="selectedStudentData.userLastName == systemUserData.userLastName" onClick="this.select();" class="w-full"  name="Title" v-model="selectedStudentData.userLastName" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Id Number</label>
            <vs-input autocomplete="off" :danger="selectedStudentData.idNumber != systemUserData.idNumber" :disabled="selectedStudentData.idNumber == systemUserData.idNumber" onClick="this.select();" class="w-full"  name="Title" v-model="selectedStudentData.idNumber" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Work</label>
            <vs-input autocomplete="off" :danger="selectedStudentData.work != systemUserData.work" :disabled="selectedStudentData.work == systemUserData.work" onClick="this.select();" class="w-full" name="Name" v-model="selectedStudentData.work" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Mobile</label>
            <vs-input autocomplete="off" :danger="selectedStudentData.mobile != systemUserData.mobile" :disabled="selectedStudentData.mobile == systemUserData.mobile" onClick="this.select();" class="w-full"  name="Title" v-model="selectedStudentData.mobile" />
          </div>
        </div>
        

        <!-- Data in DB -->
        <div class="vx-row w-1/2 pb-3">
          <div class="vx-col w-full mb-2">
            <h3>Existing Data</h3>
          </div>
          <div class="vx-col w-full mb-2">
            <label>First Name</label>
            <vs-input autocomplete="off"  disabled onClick="this.select();" class="w-full" name="Name" v-model="systemUserData.userFirstName" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Last Name</label>
            <vs-input autocomplete="off" disabled onClick="this.select();" class="w-full"  name="Title" v-model="systemUserData.userLastName" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Id Number</label>
            <vs-input autocomplete="off" disabled onClick="this.select();" class="w-full"  name="Title" v-model="systemUserData.idNumber" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Work</label>
            <vs-input autocomplete="off" disabled onClick="this.select();" class="w-full" name="Name" v-model="systemUserData.work" />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Mobile</label>
            <vs-input autocomplete="off" disabled onClick="this.select();" class="w-full"  name="Title" v-model="systemUserData.mobile" />
          </div>
        </div>
        
      </div>
      
      <div class="button-section-BulkUpload mt-2">
        <vs-button color="success" class="mr-2" @click="dataMisMatchProcessor" :disabled="!actionDropDown" >Submit</vs-button>
        <vs-button color="warning" @click="cancelAction" >Cancel</vs-button>
      </div>
    </vs-popup>
    
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      bulkFeedback: {
        students:[],
        batchInfo:{}
      },
      feedbackId: 0,
      tasksPerPage:10,
      currentTaskPage:1,
      studentDetailsActive:false,
      systemUserData:{},
      selectedStudentData:{},
      filteredBatchList:[],
      actionDropDown:null,
      showRemoved:true,
      showErrors:false,
      actionOptions:[{
        label:"Update Existing Data",
        value:"1"
      },
      {
        label:"Use Existing Data",
        value:"2"
      },{
        label:"Create New Student",
        value:"3"
      },{
        label:"Remove From Batch",
        value:"4"
      }]
    };
  },
  computed: {},
  watch: {
    showRemoved:function (changed) {
      this.filterBatchList();
    },
    showErrors:function (changed){
      this.filterBatchList();
    }
  },
  methods: {
    displayNotFound() {
      var self = this;
      self
        .$swal({
          title: "Not Found",
          icon: "error",
          html: "This bulk item was not found",
          customClass: {
            confirmButton: "vs-component vs-button vs-button-primary vs-button-filled",
          },
          buttonsStyling: false,
        })
        .then(() => {
          self.$router.push("/dashboard");
        });
    },
    getFailedDataFromUpload() {
      var self = this;
      self.studentDetailsActive = false;
      self.showLoadingOnElement("whole_page", 1, "corners");
      var onSuccess = (response) => {
        if (!response.data) {
          self.displayNotFound();
          return;
        }
        self.bulkFeedback = response.data;
        self.filterBatchList();
      };

      var onFinally = (response) => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };

      self.$ajaxGet(self,`Company/BulkUploadFeedback?uploadId=${self.feedbackId}`, onSuccess,onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    studentOptions(selectedStudent){
      if(!selectedStudent.bulkErrorTypeId){
        return;
      }
      this.selectedStudentData = selectedStudent;
      switch (selectedStudent.bulkErrorTypeId) {
        case 1:
          this.useExistingData();
          break;
        case 2:
          this.dataMisMatchFetchUserData();
          break;
        case 3:
          this.getCurrentCompanyLinkName();
          break;
        default:
          break;
      }
      
    },
    dataMisMatchFetchUserData(){
      var self = this;
      self.showLoadingOnElement("studentList",1,"corners");
      var onSuccess = response =>{
        self.systemUserData = response.data;
        self.studentDetailsActive = true;
      }
    
      var onFinally = response =>{
        if(self.$refs.studentList){
          self.$vs.loading.close(self.$refs.studentList.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/GetUserDataForMissmatch?bulkStudentId=${this.selectedStudentData.id}` , onSuccess, onFinally);
    },
    cancelAction(){
      this.studentDetailsActive = false
    },
    dataMisMatchProcessor(){
      switch (this.actionDropDown.value) {
        case "1":
          this.updateExistingData();
          break;
        case "2":
          this.useExistingData();
          break;
        case "3":
          this.addnewEmailPopup();
          break;
        case "4":
          this.areYouSureRemove();
          break;
      }
    },
    areYouSureRemove(){
      var self = this;
      this.$swal({
        title: `Are you sure you want to remove this student from the batch`,
        icon:'info',
        confirmButtonText:'Yes',
        cancelButtonText:'No',
        showCancelButton: true,
        customClass: {
          confirmButton: 'vs-component vs-button mr-2 vs-button-primary vs-button-filled',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-filled',
        },
        buttonsStyling: false,
      }).then((result)=>{
        if(result.isConfirmed){
          self.removeFromBatch();
        }
      })
    },
    useExistingData(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.getFailedDataFromUpload();
        self.$swal({
          title: 'Used Existing Details',
          icon:'success',
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          buttonsStyling: false,
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/UseExistingData?bulkStudentId=${this.selectedStudentData.id}` , onSuccess, onFinally);
    },
    updateExistingData(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.getFailedDataFromUpload();
        self.$swal({
          title: 'Student Details Updated',
          icon:'success',
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          buttonsStyling: false,
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
      self.$ajaxPost(self, `Company/UpdateExistingData` , this.selectedStudentData , onSuccess, onFinally);
    },
    addnewEmailPopup(){
      var self = this;
      self.$swal({
        title: 'Enter New Email',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          cancelButton:'vs-component vs-button vs-button-warning vs-button-filled'
        },
        showCancelButton: true,
        preConfirm: (email) => {
          self.selectedStudentData.newEmail = email;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          self.createNewStudent();
        }
      })
    },
    createNewStudent(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.studentDetailsActive = false;
        self.getFailedDataFromUpload();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
      self.$ajaxPost(self, `Company/CreateNewStudentFromBatchItem` , this.selectedStudentData , onSuccess, onFinally);
    },
    getCurrentCompanyLinkName(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.$swal({
          title: `Student is currently in`,
          html:`<strong>${response.data}</strong> <br><br> Do you want to move the Student to <strong>${self.bulkFeedback.batchInfo.company}</strong> ?`,
          icon:'info',
          confirmButtonText:'Yes',
          cancelButtonText:'No',
          showCancelButton: true,
          customClass: {
            confirmButton: 'vs-component vs-button mr-2 vs-button-primary vs-button-filled',
            cancelButton: 'vs-component vs-button vs-button-warning vs-button-filled',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            self.moveStudentToThisCompany();
          }
        })
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/CheckOtherCompanyLink?bulkStudentId=${this.selectedStudentData.id}` , onSuccess, onFinally);
    },
    moveStudentToThisCompany(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.getFailedDataFromUpload();
        self.$swal({
          title: `Student was moved`,
          icon:'success',
          showCancelButton: false,
          customClass: {
            confirmButton: 'vs-component vs-button mr-2 vs-button-primary vs-button-filled',
          },
        })
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/MoveStudentToNewCompany?bulkStudentId=${this.selectedStudentData.id}`  , onSuccess, onFinally);
    },
    removeFromBatch(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.getFailedDataFromUpload();
        self.$swal({
          title: `Student removed from batch`,
          icon:'success',
          showCancelButton: false,
          customClass: {
            confirmButton: 'vs-component vs-button mr-2 vs-button-primary vs-button-filled',
          },
        })
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Company/RemoveStudentFromBatch?bulkStudentId=${this.selectedStudentData.id}` , onSuccess, onFinally);
    },
    filterBatchList(){
      var self = this;
      if(self.showRemoved || self.showErrors){
        self.filteredBatchList = self.bulkFeedback.students.filter(function(item){
          if(self.showRemoved && !item.isActive){
            return false;
          }
          if(self.showErrors && !item.bulkErrorTypeId){
            return false;
          }
          return true;
        })
      }
      if(!self.showRemoved && !self.showErrors){
        self.filteredBatchList = self.bulkFeedback.students;
      }
    }
  },
  mounted() {
    if (this.$route.query) {
      this.feedbackId = this.$route.query.task;
    }
    this.getFailedDataFromUpload();
  },
};
</script>


<style lang="scss">
  .wrapper-Review-Data{
    justify-content: space-around;
  }

  .button-section-BulkUpload{
    justify-content: flex-end;
    display: flex;
  }
</style>